import useGetMockupInitialValues from './useGetMockupInitialValues'

export default useGetMockupInitialValues
